/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Workflow_LockedInputs */

const cs_api_error_workflow_locked = /** @type {(inputs: Api_Error_Workflow_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento workflow je zamčený jiným uživatelem.`)
};

const en_api_error_workflow_locked = /** @type {(inputs: Api_Error_Workflow_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workflow is locked by another user.`)
};

/**
* | output |
* | --- |
* | "This workflow is locked by another user." |
*
* @param {Api_Error_Workflow_LockedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_workflow_locked = /** @type {((inputs?: Api_Error_Workflow_LockedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Workflow_LockedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_workflow_locked(inputs)
	return cs_api_error_workflow_locked(inputs)
});